<template lang="pug">
  div
    .mb-2.is-flex.is-align-items-center
      div.mr-3
        p.heading.tag.m-0 {{$t(`survey_types.${value.question}`)}}
      div 
        template(v-if="value.question === 'feedback'")
          b-rate(disabled :value="value.value") 
        template(v-else-if="value.question === 'nps'")
          span.tag.has-text-weight-semibold.is-rounded(:class="value.value > 8 ? 'is-success': value.value < 7 ? 'is-danger' : 'is-warning'") {{value.value}}
        span.has-text-weight-semibold.tag.is-dark(v-else) {{value.value}}
      div.has-text-grey(style="margin-left: auto")
        date-view(:value="value.created" format="L LT")
    .mb-2.has-text-weight-semibold
        .mr-2(v-for="staffId in staff" :key="staffId" style="display: inline-flex; align-items: center")
          staff-pic.is-24x24.mr-2(:staff="staffId" size="small")
          div 
            staff-view(:id="staffId")
        
    
      
    .mb-2(v-if="value.comment")
      p {{ value.comment }}
    //.mb-2(v-else)
      p.has-text-grey(v-t="'surveys.no_comment'")
    .is-flex.is-align-items-center.mb-2
      a(@click="showCustomerDetails(value.customer._id)") {{value.customer.firstName[0]}}. {{value.customer.lastName}}
        //customer-tiny-preview(:value="value.customer" size="small" link simple)
    div(v-if="value.sale")
      invoice-view(:value="value.sale" :invoice="value.invoice") 
</template>
<script>
import {uniq} from 'lodash'
import CustomerDetailsMobile from '../customers/CustomerDetailsMobile.vue'
import Details from '../customers/Details.vue'

export default {
  name: 'SurveyResponseItem',
  props: {
    value: {type: Object, required: true}
  },
  computed: {
    staff() {
      return uniq(this.value.employees)
    }
  },
  methods: {
    showCustomerDetails(customerId) {
      this.$buefy.modal.open({
        parent: this,
        component: this.isMobile() ? CustomerDetailsMobile : Details,
        hasModalCard: true,
        fullScreen: true,
        props: {customerId},
        canCancel: ['escape', 'outside']
      })
    }
  }
}
</script>
